import React from 'react';
import dynamic from 'next/dynamic';
import { getOneFaculty } from '../../api/faculty';
const Layout = dynamic(() => import('../../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import StaffMember from '../../components/static/staff/staffMember';
import {getOneStaff} from "../../api/faculty";
const Member = (props) => {
	const meta = {
		title: "BAYAN FACULTY |  Bayan",
		description: "BAYAN AFFILIATED FACULTY HAIL FROM PREMIER INSTITUTIONS",
		route: "faculty",
	}
	return (
		<Layout theme={props.theme} meta={meta}>
			<StaffMember isLeader={props.isLeader} staff={props?.staff} />
		</Layout>
	);
}

export async function getServerSideProps(context) {
	let facId = context.query.name;
	const staff = await getOneStaff(facId)
	const isLeader = context.req.headers.referer
	return {
		props: {
			staff: staff || null,
			isLeader: isLeader || null
		},
	}
}

export default Member;
